module.exports = __webpack_public_path__ + "img/Vector 384 (2).5bab54d9.png";